import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { get, includes, map } from 'lodash';
import React, { useState, useEffect } from 'react';
// data
import pagesCollection from '../../app-event-questions/data/pages';
// faq component
import SideNav from '../../app-faq-components/SideNav';
import AvMusicForm from '../../app-event-questions/AvMusicForm';
import RestroomForm from '../../app-event-questions/RestroomForm';
import FurnitureForm from '../../app-event-questions/FurnitureForm';
import EventRulesForm from '../../app-event-questions/EventRulesForm';
import FaqContainerHOC from '../../app-faq-components/FaqContainerHOC';
import FoodBeverageForm from '../../app-event-questions/FoodBeverageForm';
import EventActivitiesForm from '../../app-event-questions/EventActivitiesForm';
import AlcoholicBeveragesForm from '../../app-event-questions/AlcoholicBeverageForm';
import { miscEventFaqDefinitions } from '../../shared-components/faq/data/eventFaqDefinition';
// shared component
import Toast from '../../shared-components/toast/toast';
const EventQuestionsContainer = ({ accessToken, space, page, listings, intl }) => {
  const pages = map(pagesCollection, ({ page }) => page);
  const spaceID = get(space, 'data._id');
  const [showToast, setShowToast] = useState(false);
  const [timeoutId, setTimeoutId ] = useState(null);
  const eventFaq = get(space, 'data.event_details', {});

  if (!includes(pages, page)) {
    window.location.href = `/your-space/${spaceID}/event-faqs/food_beverage`;
    return null;
  }

  useEffect(()=>{
    if (showToast) {
      const id = setTimeout(()=>{
        setShowToast(false);
      }, 2000);
      setTimeoutId(id);
    }
    return ()=>{
      clearTimeout(timeoutId);
    };
  }, [showToast]);

  const showErrorToast = () => {
    if (!showToast) {
      setShowToast(true);
    }
  };

  return (
    <div className="ps-row flex">
      <div className="col-xs-4" style={{ marginTop: '36px' }}>
        <SideNav
          page={page}
          spaceID={spaceID}
          linkPrefix="/your-space"
          urlSection="event-faqs"
          pagesCollection={pagesCollection}
          heading="Event FAQ"
        />
      </div>
      <div className="col-xs-8 margin-lg-top">
        <div className="flex-basis-50">
          { 'food_beverage' === page &&
            <FoodBeverageForm
              spaceId={spaceID}
              accessToken={accessToken}
              nextPage="alcoholic_beverages"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          { 'alcoholic_beverages' === page &&
            <AlcoholicBeveragesForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="food_beverage"
              nextPage="furniture"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          { 'furniture' === page &&
            <FurnitureForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="alcoholic_beverages"
              nextPage="restrooms"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          { 'restrooms' === page &&
            <RestroomForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="furniture"
              nextPage="av_music"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          { 'av_music' === page &&
            <AvMusicForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="restrooms"
              nextPage="event_activities"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          {
            'event_activities' === page &&
            <EventActivitiesForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="av_music"
              nextPage="event_rules"
              page={page}
              navPage="event"
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.next)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
          {
            'event_rules' === page &&
            <EventRulesForm
              spaceId={spaceID}
              accessToken={accessToken}
              prevPage="event_activities"
              nextPage="mylistings"
              page={page}
              navPage="event"
              listings={listings}
              submitCtaText={intl.formatMessage(miscEventFaqDefinitions.exit)}
              eventFaq={eventFaq}
              showErrorToast={showErrorToast}
            />
          }
        </div>
      </div>
      <Toast show={showToast} error />
    </div>
  );
};

EventQuestionsContainer.propTypes = {
  listings: PropTypes.array,
  accessToken: PropTypes.string,
  page: PropTypes.string,
  space: PropTypes.object,
  intl: PropTypes.object
};

export default FaqContainerHOC(injectIntl(EventQuestionsContainer));
